import React from 'react';
import { getEnvironment } from '../../utils/runtimeEnvironment';

/**
 * Badge fisso in basso a destra: "TEST" o "DEV", ben leggibile.
 * In PROD non viene mostrato nulla.
 */
export default function EnvironmentBadge() {
  const env = getEnvironment();
  if (env === 'prod') return null;

  const label = env === 'test' ? 'TEST' : 'DEV';
  const bg = env === 'test' ? '#b91c1c' : '#ea580c'; // rosso TEST, arancione DEV

  return (
    <div
      aria-hidden
      style={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 9999,
        pointerEvents: 'none',
        padding: '8px 16px',
        background: bg,
        color: '#fff',
        fontSize: 14,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        borderRadius: 6,
        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
        border: '2px solid rgba(255,255,255,0.4)',
      }}
    >
      {label}
    </div>
  );
}
